<script setup lang="ts">
    import { useDialogs } from './dialogs.store';

    const dialogs = useDialogs();
</script>
<template>
    <component
        :is="dialog.component"
        v-for="(dialog, index) of dialogs.visibleDialogs"
        :key="index"
        v-bind="dialog.props"
        @update:open="(isOpen) => !isOpen && dialogs.close(undefined)"
    />
</template>
